<template>
  <div class="contact-form-section section-space--ptb_120" id="contact">
    <div class="container">
      <div class="row">
        <div class="col-lg-7 order-2 order-lg-1">
          <div class="section-title text-left section-space--mb_60">
            <h2 class="font-weight--bold mb-15 wow move-up">聯絡我們</h2>
            <span class="section-text_left wow move-up"
              >歡迎向我們查詢各類科技方案！</span
            >
          </div>
          <div class="contact-from-wrapper wow move-up">
            <form
              id="cyberfireform"
              ref="cyberfireform"
              @submit.prevent="sendEmail"
            >
              <div class="contact-page-form">
                <div class="contact-input">
                  <div class="contact-inner field">
                    <input
                      name="name"
                      id="name"
                      type="text"
                      placeholder="名稱 *"
                      v-model="form.name"
                    />
                  </div>
                  <div class="contact-inner field">
                    <input
                      name="email"
                      id="email"
                      type="email"
                      placeholder="電郵 *"
                      v-model="form.email"
                    />
                    <p class="form-messege text-danger" v-if="!valid_email">
                      {{ valid_email_msg }}
                    </p>
                  </div>
                </div>
                <div class="contact-inner field">
                  <input
                    name="subject"
                    id="subject"
                    type="text"
                    placeholder="標題 *"
                    v-model="form.subject"
                  />
                </div>
                <div class="contact-inner contact-message field">
                  <textarea
                    name="message"
                    id="message"
                    placeholder="內容 * （告訴我們您的需求，方便我們跟進）"
                    v-model="form.msg"
                  ></textarea>
                </div>
                <div class="contact-submit-btn">
                  <input
                    class="ht-btn ht-btn-md"
                    type="submit"
                    value="發送"
                    :disabled="disable || submitted"
                  />
                  <!-- <button class="ht-btn ht-btn-md" @click="sendEmail">
                    Send message
                  </button> -->
                  <p class="form-messege" :class="{ 'text-danger': error }">
                    {{ msg.msg }}
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="col-lg-5 order-1 order-lg-2">
          <div class="peatures_image-wrap section-space--mb_40">
            <div class="image text-center wow move-up">
              <img
                class="img-fluid"
                src="../../assets/img/features/aeroland-contact-form-image-01.png"
                alt="contact thumb"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import emailjs from "@emailjs/browser";

export default {
  name: "ContactForm",

  data() {
    return {
      msg: { error: false, msg: null },
      valid_email_msg: "請輸入有效的電郵地址！",
      form: {
        name: "",
        email: "",
        msg: "",
        subject: "",
      },
      submitted: false,
    };
  },

  methods: {
    sendEmail() {
      this.submitted = true;
      const serviceID = "default_service";
      const templateID = "template_ywen8cy";

      emailjs
        .sendForm(
          serviceID,
          templateID,
          this.$refs.cyberfireform,
          "user_0pElBQjKfUzGBCKnyaCzQ"
        )
        .then(
          () => {
            this.msg = { error: false, msg: "感謝您的查詢！" };
            this.form = {
              name: "",
              email: "",
              msg: "",
              subject: "",
            };
            this.submitted = false;
          },
          () => {
            this.msg = { error: true, msg: "提交失敗，請重新嘗試！" };
            this.submitted = false;
          }
        );
    },
  },
  computed: {
    disable() {
      if (this.form.name.length == 0) return true;
      const email_regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!email_regex.test(this.form.email)) return true;
      if (this.form.msg.length == 0) return true;
      if (this.form.subject.length == 0) return true;
      return false;
    },

    valid_email() {
      if (this.form.email.length == 0) return true;
      const email_regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!email_regex.test(this.form.email)) return false;
      return true;
    },
  },
};
</script>

<style scoped>
.ht-btn.ht-btn-md:disabled {
  background-image: linear-gradient(
    218deg,
    #e9e9e9 0,
    #e9e9e9 50%,
    #e9e9e9 100%
  );
}

.section-title h2 {
  font-weight: 600;
}

.section-title span {
  font-size: 1.2rem;
}
</style>